<template>
  <v-expansion-panels flat class="flat-expanssion-panel">
    <v-expansion-panel>
      <v-expansion-panel-header ripple color="grey lighten-4" class="accent--text d-flex align-center justify-content-between">
        <v-tooltip color="white" v-if="contentJson?.lang?.[language]?.text || contentJson?.text" right content-class="tooltip-box-content" max-width="360" :open-delay="300" :close-delay="200" transition="slide-x-transition">
          <template v-slot:activator="{on, attrs}">
            <div v-bind="attrs" v-on="on" style="margin-right: -40px">
              {{ $t("nature-and-environment") }}
              <span v-if="hasAtLeastOneWarning" style="color: red; font-size: 15px">&#9888;</span>
            </div>
          </template>
          <div v-html="contentJson?.lang?.[language]?.text || contentJson?.text"></div>
        </v-tooltip>
        <div v-else>
          {{ $t("nature-and-environment") }}
          <span v-if="hasAtLeastOneWarning" style="color: red; font-size: 15px">&#9888;</span>
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-simple-table dense>
          <template v-slot:default>
            <tbody>
              <TooltipTR section="section900" field="ENV_WAT" :label="$t('proximity-to-water-500-m')">
                <div>
                  {{ $t("proximity-to-water-500-m") }}
                  <span v-if="plotItem.ENV_WAT_LABEL == 'Y'" style="color: red; font-size: 20px; line-height: 1">&#9888;</span>
                </div>
                <div>
                  {{ plotItem.ENV_WAT }} <span v-if="plotItem['ENV_WAT'] != null">{{ plotItem["ENV_WAT_UNIT"] }}</span>
                </div>
              </TooltipTR>
              <TooltipTR section="section900" field="ENV_GWA" :label="$t('groundwater-occurrence')">
                <div>{{ $t("groundwater-occurrence") }}</div>
                <div>{{ plotItem.ENV_GWA }}</div>
              </TooltipTR>
              <TooltipTR section="section900" field="ENV_FOR" :label="$t('forest-areas-and-borders')">
                <div>
                  {{ $t("forest-areas-and-borders") }}
                  <span v-if="plotItem.ENV_FOR_LABEL == 'Y'" style="color: red; font-size: 20px; line-height: 1">&#9888;</span>
                </div>
                <div>
                  {{ plotItem.ENV_FOR }} <span v-if="plotItem['ENV_FOR'] != null">{{ plotItem["ENV_FOR_UNIT"] }}</span>
                </div>
              </TooltipTR>
              <TooltipTR section="section900" field="ENV_RES" :label="$t('nature-reserves')">
                <div>
                  {{ $t("nature-reserves") }}
                  <span v-if="plotItem.ENV_RES_LABEL == 'Y'" style="color: red; font-size: 20px; line-height: 1">&#9888;</span>
                </div>
                <div>
                  {{ plotItem.ENV_RES }}
                </div>
              </TooltipTR>
              <TooltipTR section="section900" field="ENV_WAP" :label="$t('water-protection')">
                <div>
                  {{ $t("water-protection") }}
                  <span v-if="plotItem.ENV_WAP_LABEL == 'Y'" style="color: red; font-size: 20px; line-height: 1">&#9888;</span>
                </div>
                <div>
                  {{ plotItem.ENV_WAP }}
                </div>
              </TooltipTR>
              <TooltipTR section="section900" field="ENV_ELE" :label="$t('public-infrastructure-high-voltage')">
                <div>
                  {{ $t("public-infrastructure-high-voltage") }}
                  <span v-if="plotItem.ENV_ELE_LABEL == 'Y'" style="color: red; font-size: 20px; line-height: 1">&#9888;</span>
                </div>
                <div>
                  {{ plotItem.ENV_ELE }} <span v-if="plotItem['ENV_ELE'] != null">{{ plotItem["ENV_ELE_UNIT"] }}</span>
                </div>
              </TooltipTR>
              <TooltipTR section="section900" field="ENV_TRA" :label="$t('public-infrastructure-railway-network')">
                <div>
                  {{ $t("public-infrastructure-railway-network") }}
                  <span v-if="plotItem.ENV_TRA_LABEL == 'Y'" style="color: red; font-size: 20px; line-height: 1">&#9888;</span>
                </div>
                <div>
                  {{ plotItem.ENV_TRA }} <span v-if="plotItem['ENV_TRA'] != null">{{ plotItem["ENV_TRA_UNIT"] }}</span>
                </div>
              </TooltipTR>
              <TooltipTR section="section900" field="ENV_AIR" :label="$t('public-infrastructure-airport')">
                <div>
                  {{ $t("public-infrastructure-airport") }}
                  <span v-if="plotItem.ENV_AIR_LABEL == 'Y'" style="color: red; font-size: 20px; line-height: 1">&#9888;</span>
                </div>
                <div>
                  {{ plotItem.ENV_AIR }} <span v-if="plotItem['ENV_AIR'] != null">{{ plotItem["ENV_AIR_UNIT"] }}</span>
                </div>
              </TooltipTR>
            </tbody>
          </template>
        </v-simple-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script lang="ts">
import {Component, Prop, Vue} from "vue-property-decorator"
import TooltipTR from "./TooltipText.vue"

@Component({
  components: {TooltipTR},
})
export default class ViewPlotDetails300 extends Vue {
  @Prop()
  plotItem

  get hasAtLeastOneWarning() {
    if (this.plotItem.ENV_WAT_LABEL == "Y" || this.plotItem.ENV_FOR_LABEL == "Y" || this.plotItem.ENV_RES_LABEL == "Y" || this.plotItem.ENV_WAP_LABEL == "Y" || this.plotItem.ENV_ELE_LABEL == "Y" || this.plotItem.ENV_TRA_LABEL == "Y" || this.plotItem.ENV_AIR_LABEL == "Y") {
      return true
    }
    return false
  }

  contentJson: any = {}
  language

  created() {
    this.language = localStorage.getItem("user-language") || "en"
    this.loadTooltip()
  }

  async loadTooltip() {
    this.contentJson = (await this.$store.dispatch("tooltip/getTooltipContent", "section900")) || {}
  }
}
</script>
